import MobileApp from '@/pages/MobileApp';

const MobilePage = () => {
  return <MobileApp />;
};

export default MobilePage;